import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MessageSquare } from 'lucide-react';
import Button from '../ui/Button';

const CTA = () => {
  return (
    <section className="py-20 bg-gradient-to-r from-primary-600 to-secondary-600 text-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='80' height='80' viewBox='0 0 80 80' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M0 0h40v40H0V0zm40 40h40v40H40V40z' fill-opacity='0.1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}/>
      </div>

      {/* Geometric Pattern */}
      <div className="absolute right-0 top-0 w-1/3 h-full opacity-10">
        <svg viewBox="0 0 500 500" className="w-full h-full">
          <polygon points="250,60 460,400 40,400" fill="none" stroke="#d4a574" strokeWidth="2"/>
          <polygon points="250,100 420,380 80,380" fill="none" stroke="#d4a574" strokeWidth="2"/>
        </svg>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-4xl mx-auto space-y-8 animate-fade-in">
          {/* Heading */}
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
            Ready to Partner with
            <span className="block bg-gradient-to-r from-yellow-300 to-orange-400 bg-clip-text text-transparent mt-2">
              Your Sourcing Partner?
            </span>
          </h2>

          {/* Description */}
          <p className="text-lg md:text-xl text-gray-100 max-w-3xl mx-auto leading-relaxed">
            Experience the difference of working with a strategic materials partner backed by 10+ years of collective experience.
            Get premium quality, on-time delivery, and expert service for all your construction needs.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
            <Link to="/contact">
              <Button
                size="lg"
                rightIcon={<ArrowRight className="w-5 h-5" />}
                variant="secondary"
                className="w-full sm:w-auto shadow-xl"
              >
                Request a Quote
              </Button>
            </Link>
            <Link to="/products">
              <Button
                variant="outline"
                size="lg"
                leftIcon={<MessageSquare className="w-5 h-5" />}
                className="w-full sm:w-auto border-white/30 text-white hover:bg-white/10"
              >
                Browse Products
              </Button>
            </Link>
          </div>

          {/* Trust Indicators */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 pt-12 border-t border-white/20">
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-1">10+</div>
              <div className="text-sm text-gray-200">Years Experience</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-1">26+</div>
              <div className="text-sm text-gray-200">States Coverage</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-1">100%</div>
              <div className="text-sm text-gray-200">Quality Assured</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-white mb-1">24/7</div>
              <div className="text-sm text-gray-200">Support Available</div>
            </div>
          </div>

          {/* Bottom Tagline */}
          <div className="pt-8">
            <p className="text-gray-300 font-medium">
              Pan-India Supply | Reliable Sourcing | On-Time Delivery
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
